<div class="comment-section">
  <h2 mat-dialog-title>Comments</h2>
  <mat-form-field *ngIf="action === 'markStatusAsRejectedAction'" appearance="fill" class="rejection-type">
    <mat-select *ngIf="action"
      [(ngModel)]="rejectionType"
      placeholder="Select Rejection Type">
      <mat-option *ngFor="let option of GlobalConstants.REJECTION_TYPE_OPTION_LIST" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="comments-listing">
    <div class="comment-desc" *ngFor="let comments of getKeyValuePairs(commentList)">
      <span class="comment-text-value">{{ comments.value }}</span>
      <div style="margin-top: 5px;">
       <span class="date">{{ comments.key | date : 'MM/dd/yyyy hh:mm a' }}</span>
      </div>
    </div>
  </div>
  <div mat-dialog-content>
    <textarea
      name=""
      id=""
      placeholder="Please type reason"
      rows="8"
      cols="45"
      matInput
      [(ngModel)]="comment"></textarea>
  </div>
  <div mat-dialog-actions class="action-buttons">
    <button mat-button (click)="onCloseClick()">Close</button>
    <button mat-raised-button color="primary" (click)="onSave()">Save</button>
  </div>
</div>
